import React, { FC } from 'react';
import { ScanSessionJSON } from '@/common/types';
import { resultValueWithUnitsOrEmpty } from '@/common/utils';
import { ScanSessionsTableResultsWrapper } from './styles';

interface ScanSessionTableResultsProps {
    session: ScanSessionJSON;
}

export const ScanSessionsTableResults: FC<ScanSessionTableResultsProps> = ({ session }) => {
    return (
        <ScanSessionsTableResultsWrapper>
            {session ? (
                <>
                    {session.data?.results.map((result) => {
                        return (
                            <div key={result.name}>
                                <strong>{result.name}:</strong> {resultValueWithUnitsOrEmpty(result)}
                            </div>
                        );
                    })}
                </>
            ) : (
                ''
            )}
        </ScanSessionsTableResultsWrapper>
    );
};
